import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getRandomGif } from "../../../../helpers/getRandomGif";
import {
  getFoldersImages,
  SetFolder,
} from "../../../../store/slices/foldersSlice";
import { UserInfo } from "../../../../store/selectors";

import play from "../../assets/icons/play-circle-line.png";
// import share from "../../assets/icons/share.png";

import "./style.css";

export const FolderItem = ({ folder, onClick }) => {
  const { id, name, coverImageUrl, previewUrls, timePerSlide } = folder;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector(UserInfo);

  const urls = previewUrls && previewUrls.length > 0 ? previewUrls : null;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [fading, setFading] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!urls || urls.length <= 1) return;

    const interval = timePerSlide || 5000;

    intervalRef.current = setInterval(() => {
      setFading(true);

      // After the fade transition completes, swap indices
      setTimeout(() => {
        setCurrentIndex((prev) => {
          const next = (prev + 1) % urls.length;
          setNextIndex((next + 1) % urls.length);
          return next;
        });
        setFading(false);
      }, 500);
    }, interval);

    return () => clearInterval(intervalRef.current);
  }, [urls, timePerSlide]);

  const handleCarouselOpen = (e) => {
    e.stopPropagation();
    dispatch(SetFolder(folder));
    dispatch(getFoldersImages({ userId: userInfo.id, id }));
    navigate(`/player/${id}`);
  };

  function fixedName() {
    if (name.length > 15) {
      return `${name.substring(0, 8)}...`;
    } else {
      return name;
    }
  }

  const renderItems = () => {
    if (urls && urls.length > 1) {
      return (
        <>
          <img
            className="preview-slide preview-slide--back"
            src={urls[nextIndex]}
            alt="preview-next"
          />
          <img
            className={`preview-slide preview-slide--front${fading ? " preview-slide--fading" : ""}`}
            src={urls[currentIndex]}
            alt="preview-current"
          />
        </>
      );
    }

    if (urls && urls.length === 1) {
      return <img src={urls[0]} alt="preview" />;
    }

    if (coverImageUrl) {
      return <img src={coverImageUrl} alt="firstImage" />;
    }

    return <img src={getRandomGif()} alt="random_image" />;
  };

  return (
    <div className={"folder_item"} onClick={onClick}>
      <p>{fixedName()}</p>
      <div className={"images__section"}>{renderItems()}</div>
      <div className={"icons__section"}>
        <img src={play} alt="play" onClick={(e) => handleCarouselOpen(e)} />
        {/*<img src={share} alt="share" title={"share"} onClick={(e) => handleShare(e)} />*/}
      </div>
    </div>
  );
};
